<template>
    <component :is="layout"></component>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapActions } from 'vuex';

export default {
    name: 'BaseTemplate',

    components: {
        DefaultLayout: defineAsyncComponent(() => import(/* webpackChunkName: "layout" */ "@/views/template/Default.vue")),
        AuthLayout: defineAsyncComponent(() => import(/* webpackChunkName: "layout" */ "@/views/template/Auth.vue")),
    },

    data: () => ({
        defaultLayout: 'default'
    }),

    computed: {
        layout() {
            // console.log('baseLayout', this.$route.meta);
            if (this.$route.matched.some(m => m.meta.auth)) {
                return (this.$route.meta.layout || this.defaultLayout) + '-layout';
            } else {
                return 'auth-layout';
            }
        }
    },

    mounted() {
        console.log('Base template mounted');
    },

    methods: {
        //
    }
};
</script>
